var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "导入快捷短语(个人)",
        visible: _vm.visibleProxy,
        width: "960px",
        "append-to-body": "",
        "custom-class": "fri-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        }
      }
    },
    [
      _c("div", { staticClass: "fri-desc" }, [
        _vm._v("添加导入：在现有快捷短语后方增加新导入的短语")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fri-file-row" },
        [
          _c("div", { staticClass: "fri-label" }, [_vm._v("文件路径：")]),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "fri-input",
            attrs: {
              placeholder: "/Users/xxx/Downloads/快捷短语.csv",
              size: "small"
            },
            model: {
              value: _vm.filePath,
              callback: function($$v) {
                _vm.filePath = $$v
              },
              expression: "filePath"
            }
          }),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            staticClass: "fri-file",
            attrs: { type: "file", accept: ".csv,.txt,.xls,.xlsx" },
            on: { change: _vm.onFileChange }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "fri-choose",
              attrs: { size: "small" },
              on: { click: _vm.chooseFile }
            },
            [_vm._v("选择文件")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "fri-table",
          attrs: { data: _vm.tableData, border: "", height: "380" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "index",
              label: "编号",
              width: "70",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "code", label: "短语编码", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "content",
              label: "短语内容",
              "min-width": "260",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "group", label: "分组名", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "image",
              label: "图片(仅支持链接)",
              "min-width": "180",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              width: "100",
              align: "center"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35b1d312", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b1d312","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/components/FastReplyImportDialog.vue
// module id = 1708
// module chunks = 0